var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-radio-trigger", class: _vm.computedClass },
    _vm._l(_vm.options, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "component-item",
          class: _vm.getItemClass(item),
          style: { width: _vm.itemWidth },
          on: {
            click: function($event) {
              return _vm.handleClickItem(item)
            }
          }
        },
        [
          _c("div", { staticClass: "item-text w-bold" }, [
            _vm._v(_vm._s(item.label))
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }